/* Cloverfen polish layer: staggered section entrances and a count up on big numbers.
   Elements are only hidden after this script tags them, so content never stays
   hidden if the script fails to load. */
(function () {
  if (window.cfPolishInit) return;
  window.cfPolishInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  var GROUPS = [
    '.cf-hero__copy > *',
    '.cf-modes__head > *', '.cf-modes__item',
    '.cf-cp__copy > *', '.cf-cp__wrap',
    '.cf-ins__head > *', '.cf-ins__item', '.cf-ins__foot',
    '.cf-stat__head > *', '.cf-stat__item',
    '.cf-res__head > *', '.cf-res__grid',
    '.cf-og__box',
    '.cf-rv__head > *', '.cf-rv__grid > li',
    '.cf-gs__head > *', '.cf-gs__item', '.cf-gs__total',
    '.cf-sc__copy > *', '.cf-sc__cell',
    '.multicolumn__title', '.multicolumn-list__item',
    '.image-with-text__content > *',
    '.rich-text__blocks > *',
    '.collapsible-content__header', '.collapsible-content .accordion',
    '.icon-bar .title', '.icon-bar .multicolumn-list__item',
    '.cf-pb__photo', '.cf-pb__copy > .cf-h2', '.cf-pb__copy > .cf-lead', '.cf-pb__row',
    '.cf-fm__head > *', '.cf-fm__card', '.cf-fm__center',
    '.cf-bs__title', '.cf-bs__row', '.cf-bs__media',
    '.cf-fq__collage', '.cf-fq__copy > .cf-h2', '.cf-fq__sub', '.cf-fq__item'
  ];

  function tag(root) {
    var seen = new Map();
    root.querySelectorAll(GROUPS.join(',')).forEach(function (el) {
      if (el.closest('.product__info-container')) return;
      var parent = el.parentElement;
      var i = seen.get(parent) || 0;
      seen.set(parent, i + 1);
      el.setAttribute('data-cf-reveal', '');
      el.style.setProperty('--cf-i', Math.min(i, 6));
    });
  }

  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([^0-9]*)([0-9][0-9,]*)(.*)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!target || target < 10) return;
    var start = null, dur = 1600;
    function fmt(n) { return m[2].indexOf(',') > -1 ? n.toLocaleString('en-US') : String(n); }
    function step(t) {
      if (start === null) start = t;
      var p = Math.min((t - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 4);
      el.textContent = m[1] + fmt(Math.round(target * e)) + m[3];
      if (p < 1) requestAnimationFrame(step);
    }
    el.textContent = m[1] + fmt(0) + m[3];
    requestAnimationFrame(step);
  }

  function init() {
    var main = document.getElementById('MainContent');
    if (!main || reduce || designMode || !('IntersectionObserver' in window)) return;
    tag(main);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    main.querySelectorAll('[data-cf-reveal]').forEach(function (el) { io.observe(el); });

    var nums = main.querySelectorAll('.cf-sc__num, .cf-fq__num');
    var nio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countUp(entry.target);
        nio.unobserve(entry.target);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (el) { nio.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* fallback page transition for browsers without cross document View Transitions */
(function () {
  if ('onpagereveal' in window) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var overlay;
  function ensure() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'cf-pt';
    overlay.setAttribute('aria-hidden', 'true');
    var fav = document.querySelector('link[rel~="icon"]');
    if (fav) { var i = document.createElement('img'); i.src = fav.href; i.alt = ''; overlay.appendChild(i); }
    document.body.appendChild(overlay);
    return overlay;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname.indexOf('/products/') !== 0) return;
    if (url.pathname === location.pathname) return;
    e.preventDefault();
    ensure().classList.add('is-on');
    setTimeout(function () { location.href = url.href; }, 260);
  });
  window.addEventListener('pageshow', function () { if (overlay) overlay.classList.remove('is-on'); });
})();
